// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import { backgroundTasksTasksRetrieveResponseTransformer, directoutreachBetanxtVoterPolicySnapshotExportCreateResponseTransformer, directoutreachPolicyAvailableListResponseTransformer, directoutreachPolicyAvailableRetrieveResponseTransformer, directoutreachPolicyCreateResponseTransformer, directoutreachVotersCreateCreateResponseTransformer, directoutreachVotersHoldingsRetrieveResponseTransformer, directoutreachVotersSelectedPolicyCreateResponseTransformer, directoutreachVotersSelectedPolicyRetrieveResponseTransformer, fundManagerFundManagersCreateResponseTransformer, fundManagerFundManagersListResponseTransformer, fundManagerFundManagersRetrieveResponseTransformer, fundManagerFundManagersUpdateResponseTransformer, institutionalMeetingsearchListResponseTransformer, proxyvotingEntitlementsListResponseTransformer, proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponseTransformer, proxyvotingFundManagerPolicySupportedIssuedInstrumentsListResponseTransformer, proxyvotingFundManagerSupportedPoliciesCreateResponseTransformer, proxyvotingFundManagerSupportedPoliciesListResponseTransformer, proxyvotingInvestorCompositionsDifferenceListResponseTransformer, proxyvotingInvestorCompositionsRulesEngineRetrieveResponseTransformer, proxyvotingInvestorCompositionsRulesEngineUpdateResponseTransformer, proxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponseTransformer, proxyvotingInvestorPolicySupportedIssuedInstrumentsListResponseTransformer, proxyvotingInvestorSupportedIssuedInstrumentsCreateResponseTransformer, proxyvotingInvestorSupportedIssuedInstrumentsListResponseTransformer, proxyvotingMeetingBallotsListResponseTransformer, proxyvotingMeetingBallotSourcesListResponseTransformer, proxyvotingPiballotsFilterListResponseTransformer, proxyvotingPimeetingsFilterListResponseTransformer, proxyvotingRulesEngineDefinitionsCreateResponseTransformer, proxyvotingRulesEngineDefinitionsListResponseTransformer, proxyvotingRulesEngineDefinitionsRetrieveResponseTransformer, proxyvotingRulesEngineDefinitionsRulesCreateResponseTransformer, proxyvotingRulesEngineDefinitionsRulesListResponseTransformer, proxyvotingRulesEngineDefinitionsRulesUpdateResponseTransformer, proxyvotingSviProposalOverwriteCreateResponseTransformer, transparencyPublicSecurityIdsListResponseTransformer, votingOperationsPiballotsFilterListResponseTransformer, votingOperationsPimeetingsFilterListResponseTransformer } from './transformers.gen';
import type { ApiSchemaRetrieveData, ApiSchemaRetrieveResponses, BackgroundTasksTasksRetrieveData, BackgroundTasksTasksRetrieveErrors, BackgroundTasksTasksRetrieveResponses, DirectoutreachBetanxtVoterPolicySnapshotExportCreateData, DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses, DirectoutreachPolicyAvailableListData, DirectoutreachPolicyAvailableListResponses, DirectoutreachPolicyAvailableRetrieveData, DirectoutreachPolicyAvailableRetrieveResponses, DirectoutreachPolicyCreateData, DirectoutreachPolicyCreateResponses, DirectoutreachVotersBatchCreateCreateData, DirectoutreachVotersBatchCreateCreateErrors, DirectoutreachVotersBatchCreateCreateResponses, DirectoutreachVotersCreateCreateData, DirectoutreachVotersCreateCreateResponses, DirectoutreachVotersHoldingsRetrieveData, DirectoutreachVotersHoldingsRetrieveErrors, DirectoutreachVotersHoldingsRetrieveResponses, DirectoutreachVotersRetrieveData, DirectoutreachVotersRetrieveErrors, DirectoutreachVotersRetrieveResponses, DirectoutreachVotersSelectedPolicyCreateData, DirectoutreachVotersSelectedPolicyCreateErrors, DirectoutreachVotersSelectedPolicyCreateResponses, DirectoutreachVotersSelectedPolicyRetrieveData, DirectoutreachVotersSelectedPolicyRetrieveErrors, DirectoutreachVotersSelectedPolicyRetrieveResponses, FundManagerFundManagersCreateData, FundManagerFundManagersCreateResponses, FundManagerFundManagersListData, FundManagerFundManagersListResponses, FundManagerFundManagersRetrieveData, FundManagerFundManagersRetrieveResponses, FundManagerFundManagersUpdateData, FundManagerFundManagersUpdateResponses, InstitutionalMeetingsearchListData, InstitutionalMeetingsearchListResponses, ProxyvotingEntitlementsBreakdownCreateData, ProxyvotingEntitlementsBreakdownCreateResponses, ProxyvotingEntitlementsComputeCreateData, ProxyvotingEntitlementsComputeCreateResponses, ProxyvotingEntitlementsListData, ProxyvotingEntitlementsListResponses, ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateData, ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateResponses, ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateData, ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses, ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateData, ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses, ProxyvotingFundManagerPolicySupportedIssuedInstrumentsListData, ProxyvotingFundManagerPolicySupportedIssuedInstrumentsListResponses, ProxyvotingFundManagerSupportedPoliciesCreateData, ProxyvotingFundManagerSupportedPoliciesCreateResponses, ProxyvotingFundManagerSupportedPoliciesDestroyData, ProxyvotingFundManagerSupportedPoliciesDestroyResponses, ProxyvotingFundManagerSupportedPoliciesListData, ProxyvotingFundManagerSupportedPoliciesListResponses, ProxyvotingInvestorCompositionsDifferenceListData, ProxyvotingInvestorCompositionsDifferenceListResponses, ProxyvotingInvestorCompositionsRenderCreateData, ProxyvotingInvestorCompositionsRenderCreateResponses, ProxyvotingInvestorCompositionsRulesEngineRetrieveData, ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses, ProxyvotingInvestorCompositionsRulesEngineUpdateData, ProxyvotingInvestorCompositionsRulesEngineUpdateResponses, ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateData, ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateResponses, ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateData, ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses, ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateData, ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses, ProxyvotingInvestorPolicySupportedIssuedInstrumentsListData, ProxyvotingInvestorPolicySupportedIssuedInstrumentsListResponses, ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateData, ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses, ProxyvotingInvestorSupportedIssuedInstrumentsCreateData, ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses, ProxyvotingInvestorSupportedIssuedInstrumentsListData, ProxyvotingInvestorSupportedIssuedInstrumentsListResponses, ProxyvotingMeetingballotsComputeCreateData, ProxyvotingMeetingballotsComputeCreateResponses, ProxyvotingMeetingBallotsListData, ProxyvotingMeetingBallotsListResponses, ProxyvotingMeetingBallotSourcesListData, ProxyvotingMeetingBallotSourcesListResponses, ProxyvotingPiballotsFilterListData, ProxyvotingPiballotsFilterListResponses, ProxyvotingPiballotsInvestorsCanVoteCreateData, ProxyvotingPiballotsInvestorsCanVoteCreateResponses, ProxyvotingPimeetingsFilterListData, ProxyvotingPimeetingsFilterListResponses, ProxyvotingRulesEngineDefinitionsByNameDestroyData, ProxyvotingRulesEngineDefinitionsByNameDestroyErrors, ProxyvotingRulesEngineDefinitionsByNameDestroyResponses, ProxyvotingRulesEngineDefinitionsCreateData, ProxyvotingRulesEngineDefinitionsCreateResponses, ProxyvotingRulesEngineDefinitionsDestroyData, ProxyvotingRulesEngineDefinitionsDestroyErrors, ProxyvotingRulesEngineDefinitionsDestroyResponses, ProxyvotingRulesEngineDefinitionsListData, ProxyvotingRulesEngineDefinitionsListResponses, ProxyvotingRulesEngineDefinitionsNamesRetrieveData, ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses, ProxyvotingRulesEngineDefinitionsRetrieveData, ProxyvotingRulesEngineDefinitionsRetrieveResponses, ProxyvotingRulesEngineDefinitionsRulesCreateData, ProxyvotingRulesEngineDefinitionsRulesCreateResponses, ProxyvotingRulesEngineDefinitionsRulesDestroyData, ProxyvotingRulesEngineDefinitionsRulesDestroyResponses, ProxyvotingRulesEngineDefinitionsRulesListData, ProxyvotingRulesEngineDefinitionsRulesListResponses, ProxyvotingRulesEngineDefinitionsRulesUpdateData, ProxyvotingRulesEngineDefinitionsRulesUpdateResponses, ProxyvotingSviProposalOverwriteCreateData, ProxyvotingSviProposalOverwriteCreateResponses, ProxyvotingSviProposalOverwriteReasonsListData, ProxyvotingSviProposalOverwriteReasonsListResponses, TransparencyInstrumentsCreateData, TransparencyInstrumentsCreateResponses, TransparencyInstrumentsDestroyData, TransparencyInstrumentsDestroyResponses, TransparencyInstrumentsFetchMinimalCreateData, TransparencyInstrumentsFetchMinimalCreateResponses, TransparencyInstrumentsListData, TransparencyInstrumentsListResponses, TransparencyInstrumentsRetrieveData, TransparencyInstrumentsRetrieveResponses, TransparencyInstrumentsUnassociatedRetrieveData, TransparencyInstrumentsUnassociatedRetrieveResponses, TransparencyInstrumentsUpdateData, TransparencyInstrumentsUpdateResponses, TransparencyPublicSecurityIdsListData, TransparencyPublicSecurityIdsListResponses, VotingOperationsPiballotsFilterListData, VotingOperationsPiballotsFilterListResponses, VotingOperationsPimeetingsFilterListData, VotingOperationsPimeetingsFilterListResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const apiSchemaRetrieve = <ThrowOnError extends boolean = false>(options?: Options<ApiSchemaRetrieveData, ThrowOnError>) => (options?.client ?? client).get<ApiSchemaRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema/',
    ...options
});

/**
 * Get task status
 *
 * Retrieve the current status and result of a background task by its ID.
 */
export const backgroundTasksTasksRetrieve = <ThrowOnError extends boolean = false>(options: Options<BackgroundTasksTasksRetrieveData, ThrowOnError>) => (options.client ?? client).get<BackgroundTasksTasksRetrieveResponses, BackgroundTasksTasksRetrieveErrors, ThrowOnError>({
    responseTransformer: backgroundTasksTasksRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/background-tasks/tasks/{task_id}/',
    ...options
});

/**
 * Export BetaNXT voter policies snapshot to S3
 *
 * Exports voter policies data to S3 as CSV. Includes holdings for the specified valid_time with policy selections. When multiple holdings exist for the same date, selects the most recent. Synchronous operation with 60s timeout. Requires timezone-aware datetime.
 */
export const directoutreachBetanxtVoterPolicySnapshotExportCreate = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachBetanxtVoterPolicySnapshotExportCreateData, ThrowOnError>) => (options.client ?? client).post<DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachBetanxtVoterPolicySnapshotExportCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directoutreach/betanxt/voter-policy-snapshot:export/',
    ...options
});

/**
 * Create a new voting policy
 *
 * Creates a new voting policy with the provided information.
 */
export const directoutreachPolicyCreate = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachPolicyCreateData, ThrowOnError>) => (options.client ?? client).post<DirectoutreachPolicyCreateResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachPolicyCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directoutreach/policy/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all available voting policies
 *
 * Retrieves a list of all voting available policies.
 */
export const directoutreachPolicyAvailableList = <ThrowOnError extends boolean = false>(options?: Options<DirectoutreachPolicyAvailableListData, ThrowOnError>) => (options?.client ?? client).get<DirectoutreachPolicyAvailableListResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachPolicyAvailableListResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/policy/available/',
    ...options
});

/**
 * ViewSet for retrieving available voting policies.
 */
export const directoutreachPolicyAvailableRetrieve = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachPolicyAvailableRetrieveData, ThrowOnError>) => (options.client ?? client).get<DirectoutreachPolicyAvailableRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachPolicyAvailableRetrieveResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/policy/available/{id}/',
    ...options
});

/**
 * Get voter's details
 *
 * Retrieves the details for the specified voter, including their ID and broker ID. Use 'mine' as the voter ID to get your own details.
 */
export const directoutreachVotersRetrieve = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachVotersRetrieveData, ThrowOnError>) => (options.client ?? client).get<DirectoutreachVotersRetrieveResponses, DirectoutreachVotersRetrieveErrors, ThrowOnError>({
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/voters/{id}/',
    ...options
});

/**
 * List latest voter's holdings
 *
 * Retrieves the holdings for the specified voter. Use 'mine' as the voter ID to get your own holdings.
 */
export const directoutreachVotersHoldingsRetrieve = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachVotersHoldingsRetrieveData, ThrowOnError>) => (options.client ?? client).get<DirectoutreachVotersHoldingsRetrieveResponses, DirectoutreachVotersHoldingsRetrieveErrors, ThrowOnError>({
    responseTransformer: directoutreachVotersHoldingsRetrieveResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/voters/{id}/holdings/',
    ...options
});

/**
 * Get voter's selected policy
 *
 * Retrieves the voting policy selected by the specified voter. Use 'mine' as the voter ID to get your own selected policy.
 */
export const directoutreachVotersSelectedPolicyRetrieve = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachVotersSelectedPolicyRetrieveData, ThrowOnError>) => (options.client ?? client).get<DirectoutreachVotersSelectedPolicyRetrieveResponses, DirectoutreachVotersSelectedPolicyRetrieveErrors, ThrowOnError>({
    responseTransformer: directoutreachVotersSelectedPolicyRetrieveResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/voters/{id}/selected-policy/',
    ...options
});

/**
 * Create a new selected policy version
 *
 * Creates a new selected policy record for the specified voter. Use 'mine' as the voter ID to create your own selected policy.
 */
export const directoutreachVotersSelectedPolicyCreate = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachVotersSelectedPolicyCreateData, ThrowOnError>) => (options.client ?? client).post<DirectoutreachVotersSelectedPolicyCreateResponses, DirectoutreachVotersSelectedPolicyCreateErrors, ThrowOnError>({
    responseTransformer: directoutreachVotersSelectedPolicyCreateResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/voters/{id}/selected-policy/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Batch create voters with holdings (atomic)
 *
 * Atomically creates or updates multiple voters and their holdings.
 *
 * Each voter is identified by (mediant_id, broker_id). Holdings are created as new records, preserving complete historical data.
 */
export const directoutreachVotersBatchCreateCreate = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachVotersBatchCreateCreateData, ThrowOnError>) => (options.client ?? client).post<DirectoutreachVotersBatchCreateCreateResponses, DirectoutreachVotersBatchCreateCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directoutreach/voters:batch-create/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upsert voter with holdings
 *
 * Creates or updates a voter and creates new version of their holdings. Voters are identified by (mediant_id, broker_id). Each request creates new holding records, preserving complete historical data. Queries return only the latest version of each holding.
 *
 *
 */
export const directoutreachVotersCreateCreate = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachVotersCreateCreateData, ThrowOnError>) => (options.client ?? client).post<DirectoutreachVotersCreateCreateResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachVotersCreateCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directoutreach/voters:create/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List fund managers
 */
export const fundManagerFundManagersList = <ThrowOnError extends boolean = false>(options?: Options<FundManagerFundManagersListData, ThrowOnError>) => (options?.client ?? client).get<FundManagerFundManagersListResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/',
    ...options
});

/**
 * Create a fund manager
 */
export const fundManagerFundManagersCreate = <ThrowOnError extends boolean = false>(options: Options<FundManagerFundManagersCreateData, ThrowOnError>) => (options.client ?? client).post<FundManagerFundManagersCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a fund manager
 */
export const fundManagerFundManagersRetrieve = <ThrowOnError extends boolean = false>(options: Options<FundManagerFundManagersRetrieveData, ThrowOnError>) => (options.client ?? client).get<FundManagerFundManagersRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/{id}/',
    ...options
});

/**
 * Update a fund manager
 */
export const fundManagerFundManagersUpdate = <ThrowOnError extends boolean = false>(options: Options<FundManagerFundManagersUpdateData, ThrowOnError>) => (options.client ?? client).put<FundManagerFundManagersUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List meetings with filtering and cursor pagination.
 */
export const institutionalMeetingsearchList = <ThrowOnError extends boolean = false>(options: Options<InstitutionalMeetingsearchListData, ThrowOnError>) => (options.client ?? client).get<InstitutionalMeetingsearchListResponses, unknown, ThrowOnError>({
    responseTransformer: institutionalMeetingsearchListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/institutional/meetingsearch',
    ...options
});

/**
 * List ballot entitlements
 *
 * Returns ballot entitlements, optionally filtered by proxy_intermediary_ballot_id or investor_account_id. By default, only active entitlements (invalid_time is null) are returned. Set include_invalid=true to include invalidated entitlements.
 */
export const proxyvotingEntitlementsList = <ThrowOnError extends boolean = false>(options?: Options<ProxyvotingEntitlementsListData, ThrowOnError>) => (options?.client ?? client).get<ProxyvotingEntitlementsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingEntitlementsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/entitlements',
    ...options
});

/**
 * Compute ballot breakdown synchronously
 *
 * Computes the ballot breakdown for a proxy intermediary ballot with specified filters. Returns the full graph structure in JSON format. This is a synchronous operation.
 */
export const proxyvotingEntitlementsBreakdownCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingEntitlementsBreakdownCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingEntitlementsBreakdownCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/entitlements/breakdown',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger entitlements computation
 *
 * Enqueues an entitlements computation task to run asynchronously. Returns task_id to check status
 */
export const proxyvotingEntitlementsComputeCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingEntitlementsComputeCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingEntitlementsComputeCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/entitlements:compute',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Fund Manager Supported Issued Instruments
 *
 * Updates a fund manager's Supported Issued Instruments for the given voting policies and ISINs. Adds new instruments and invalidates existing instruments not in the provided list.
 */
export const proxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/compositions/sii/from-composition-difference',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List fund manager policy supported issued instruments
 *
 * Lists fund manager policy supported issued instruments for a given set of public security ID names, fund manager names, policy names, and an indicator as to whether the response should include or exclude deleted items.
 */
export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsList = <ThrowOnError extends boolean = false>(options?: Options<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsListData, ThrowOnError>) => (options?.client ?? client).get<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingFundManagerPolicySupportedIssuedInstrumentsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/policy-supported-issued-instruments',
    ...options
});

/**
 * Batch create fund manager policy supported issued instruments
 *
 * Creates fund manager policy supported issued instruments for the given fund manager and voting policy. Instruments that already exist are silently ignored (no-op).
 */
export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/policy-supported-issued-instruments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Batch delete fund manager policy supported issued instruments
 *
 * Soft-deletes fund manager policy supported issued instruments by name (sets delete_time and valid_to).
 */
export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/policy-supported-issued-instruments/batch-delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List fund manager supported policies
 *
 * Returns all fund manager / voting policy links, optionally filtered. Supply as_of to fetch the historical state at a specific point in time.
 */
export const proxyvotingFundManagerSupportedPoliciesList = <ThrowOnError extends boolean = false>(options?: Options<ProxyvotingFundManagerSupportedPoliciesListData, ThrowOnError>) => (options?.client ?? client).get<ProxyvotingFundManagerSupportedPoliciesListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingFundManagerSupportedPoliciesListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/supported-policies',
    ...options
});

/**
 * Batch upsert fund manager supported policies
 *
 * Creates or ensures existence of fund manager / voting policy links. All upserts are applied atomically.
 */
export const proxyvotingFundManagerSupportedPoliciesCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingFundManagerSupportedPoliciesCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingFundManagerSupportedPoliciesCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingFundManagerSupportedPoliciesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/supported-policies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a fund manager supported policy
 *
 * Deletes the fund manager / voting policy link with the given ID.
 */
export const proxyvotingFundManagerSupportedPoliciesDestroy = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingFundManagerSupportedPoliciesDestroyData, ThrowOnError>) => (options.client ?? client).delete<ProxyvotingFundManagerSupportedPoliciesDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/supported-policies/{id}',
    ...options
});

/**
 * Get composition differences
 *
 * Fetches and compares investor compositions between two time periods
 */
export const proxyvotingInvestorCompositionsDifferenceList = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingInvestorCompositionsDifferenceListData, ThrowOnError>) => (options.client ?? client).get<ProxyvotingInvestorCompositionsDifferenceListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorCompositionsDifferenceListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/difference',
    ...options
});

export const proxyvotingInvestorCompositionsRenderCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingInvestorCompositionsRenderCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingInvestorCompositionsRenderCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/render',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get investor rules engine mapping
 *
 * Retrieves the rules engine mapping for a specific investor. Requires vops.administrator role.
 */
export const proxyvotingInvestorCompositionsRulesEngineRetrieve = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingInvestorCompositionsRulesEngineRetrieveData, ThrowOnError>) => (options.client ?? client).get<ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorCompositionsRulesEngineRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/rules-engine',
    ...options
});

/**
 * Map investor to rules engine
 *
 * Upserts mapping between an investor and their voting rules engine. Returns 201 for new mappings, 200 for updates. Requires vops.administrator role.
 */
export const proxyvotingInvestorCompositionsRulesEngineUpdate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingInvestorCompositionsRulesEngineUpdateData, ThrowOnError>) => (options.client ?? client).put<ProxyvotingInvestorCompositionsRulesEngineUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorCompositionsRulesEngineUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/rules-engine',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Supported Issued Instruments from composition difference
 *
 * Updates an investor's Supported Issued Instruments based on a provided composition difference. Adds new instruments and invalidates removed instruments.
 */
export const proxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/sii/from-composition-difference',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List investor policy supported issued instruments
 *
 * Lists investor policy supported issued instruments for a given set of public security ID names, investor names, policy names, and an indicator as to whether the response should include or exclude deleted items.
 */
export const proxyvotingInvestorPolicySupportedIssuedInstrumentsList = <ThrowOnError extends boolean = false>(options?: Options<ProxyvotingInvestorPolicySupportedIssuedInstrumentsListData, ThrowOnError>) => (options?.client ?? client).get<ProxyvotingInvestorPolicySupportedIssuedInstrumentsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorPolicySupportedIssuedInstrumentsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/policy-supported-issued-instruments',
    ...options
});

/**
 * Batch create investor policy supported issued instruments
 *
 * Creates investor policy supported issued instruments for the given investor and voting policy. Instruments that already exist are silently ignored (no-op).
 */
export const proxyvotingInvestorPolicySupportedIssuedInstrumentsCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/policy-supported-issued-instruments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Batch delete investor policy supported issued instruments
 *
 * Soft-deletes investor policy supported issued instruments by name (sets delete_time and valid_to).
 */
export const proxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/policy-supported-issued-instruments/batch-delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List investor supported issued instruments
 *
 * Lists investor supported issued instruments. If no filters are provided, all records are returned.
 */
export const proxyvotingInvestorSupportedIssuedInstrumentsList = <ThrowOnError extends boolean = false>(options?: Options<ProxyvotingInvestorSupportedIssuedInstrumentsListData, ThrowOnError>) => (options?.client ?? client).get<ProxyvotingInvestorSupportedIssuedInstrumentsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorSupportedIssuedInstrumentsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/supported-issued-instruments',
    ...options
});

/**
 * Batch create investor supported issued instruments
 *
 * Creates investor supported issued instruments for the given investor. Instruments that already exist are silently ignored (no-op).
 */
export const proxyvotingInvestorSupportedIssuedInstrumentsCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingInvestorSupportedIssuedInstrumentsCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorSupportedIssuedInstrumentsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/supported-issued-instruments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Batch delete investor supported issued instruments
 *
 * Soft-deletes investor supported issued instruments by name (sets delete_time and valid_to).
 */
export const proxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/supported-issued-instruments/batch-delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List meeting ballot sources
 *
 * Returns meeting ballot sources, optionally filtered by meeting_ballot_id or proxy_intermediary_ballot_id. By default, only active sources (invalid_time is null) are returned. Set include_invalid=true to include invalidated sources.
 */
export const proxyvotingMeetingBallotSourcesList = <ThrowOnError extends boolean = false>(options?: Options<ProxyvotingMeetingBallotSourcesListData, ThrowOnError>) => (options?.client ?? client).get<ProxyvotingMeetingBallotSourcesListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingMeetingBallotSourcesListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/meeting-ballot-sources',
    ...options
});

/**
 * List meeting ballots
 *
 * Returns meeting ballots, optionally filtered by investor_id or general_meeting_id.
 */
export const proxyvotingMeetingBallotsList = <ThrowOnError extends boolean = false>(options?: Options<ProxyvotingMeetingBallotsListData, ThrowOnError>) => (options?.client ?? client).get<ProxyvotingMeetingBallotsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingMeetingBallotsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/meeting-ballots',
    ...options
});

/**
 * Trigger meeting ballot handout processing
 *
 * Enqueues a meeting ballot handout task to run asynchronously. Returns task_id to check status
 */
export const proxyvotingMeetingballotsComputeCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingMeetingballotsComputeCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingMeetingballotsComputeCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/meetingballots:compute',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Filter proxy intermediary ballot search results with cursor-based pagination.
 */
export const proxyvotingPiballotsFilterList = <ThrowOnError extends boolean = false>(options?: Options<ProxyvotingPiballotsFilterListData, ThrowOnError>) => (options?.client ?? client).get<ProxyvotingPiballotsFilterListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingPiballotsFilterListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/piballots/filter',
    ...options
});

/**
 * Compute investor accounts who can vote on ballots, and whether investigation is required the ballot
 *
 * For each provided ballot ID, returns the number of investor accounts expected to vote, their individual fund proportions, and whether the ballot requires investigation due to potentially missing or inaccurate entitlements data.
 */
export const proxyvotingPiballotsInvestorsCanVoteCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingPiballotsInvestorsCanVoteCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingPiballotsInvestorsCanVoteCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/piballots/investors-can-vote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Filter proxy intermediary meeting search results with cursor-based pagination. Returns meetings that are in scope for voting operations workflow, along with their scope information.
 */
export const proxyvotingPimeetingsFilterList = <ThrowOnError extends boolean = false>(options?: Options<ProxyvotingPimeetingsFilterListData, ThrowOnError>) => (options?.client ?? client).get<ProxyvotingPimeetingsFilterListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingPimeetingsFilterListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/pimeetings/filter',
    ...options
});

/**
 * List rules engine definitions
 *
 * Returns all rules engine definition versions, optionally filtered by name.
 */
export const proxyvotingRulesEngineDefinitionsList = <ThrowOnError extends boolean = false>(options?: Options<ProxyvotingRulesEngineDefinitionsListData, ThrowOnError>) => (options?.client ?? client).get<ProxyvotingRulesEngineDefinitionsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions',
    ...options
});

/**
 * Create a rules engine definition
 *
 * Creates a new rules engine definition version.
 */
export const proxyvotingRulesEngineDefinitionsCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingRulesEngineDefinitionsCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingRulesEngineDefinitionsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List rules for a definition
 *
 * Returns all rules for the given rules engine definition, ordered by rule order.
 */
export const proxyvotingRulesEngineDefinitionsRulesList = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingRulesEngineDefinitionsRulesListData, ThrowOnError>) => (options.client ?? client).get<ProxyvotingRulesEngineDefinitionsRulesListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsRulesListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules',
    ...options
});

/**
 * Create a rule
 *
 * Creates a new rule within the given rules engine definition.
 */
export const proxyvotingRulesEngineDefinitionsRulesCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingRulesEngineDefinitionsRulesCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingRulesEngineDefinitionsRulesCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsRulesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a rule
 *
 * Deletes the rule with the given ID within the given definition.
 */
export const proxyvotingRulesEngineDefinitionsRulesDestroy = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingRulesEngineDefinitionsRulesDestroyData, ThrowOnError>) => (options.client ?? client).delete<ProxyvotingRulesEngineDefinitionsRulesDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules/{id}',
    ...options
});

/**
 * Update a rule
 *
 * Replaces all fields of the rule with the given ID within the given definition.
 */
export const proxyvotingRulesEngineDefinitionsRulesUpdate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingRulesEngineDefinitionsRulesUpdateData, ThrowOnError>) => (options.client ?? client).put<ProxyvotingRulesEngineDefinitionsRulesUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsRulesUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a rules engine definition
 *
 * Deletes the definition with the given ID and its associated rules. Returns 409 if this is the last definition for its name — use DELETE /rules-engine-definitions/by-name/{name} to delete the engine entirely.
 */
export const proxyvotingRulesEngineDefinitionsDestroy = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingRulesEngineDefinitionsDestroyData, ThrowOnError>) => (options.client ?? client).delete<ProxyvotingRulesEngineDefinitionsDestroyResponses, ProxyvotingRulesEngineDefinitionsDestroyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{id}',
    ...options
});

/**
 * Retrieve a rules engine definition
 *
 * Returns the rules engine definition with the given ID.
 */
export const proxyvotingRulesEngineDefinitionsRetrieve = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingRulesEngineDefinitionsRetrieveData, ThrowOnError>) => (options.client ?? client).get<ProxyvotingRulesEngineDefinitionsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{id}',
    ...options
});

/**
 * Delete all definitions for a name
 *
 * Deletes all versioned definitions with the given name and their associated rules. Returns 409 if the name is the Tumelo base engine or if any investor is configured to use this rules engine. Returns 404 if no definitions exist with the given name.
 */
export const proxyvotingRulesEngineDefinitionsByNameDestroy = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingRulesEngineDefinitionsByNameDestroyData, ThrowOnError>) => (options.client ?? client).delete<ProxyvotingRulesEngineDefinitionsByNameDestroyResponses, ProxyvotingRulesEngineDefinitionsByNameDestroyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/by-name/{name}',
    ...options
});

/**
 * List rules engine names
 *
 * Returns the distinct names of all rules engines, sorted alphabetically. Use this to render a list of available rules engines before fetching their versions.
 */
export const proxyvotingRulesEngineDefinitionsNamesRetrieve = <ThrowOnError extends boolean = false>(options?: Options<ProxyvotingRulesEngineDefinitionsNamesRetrieveData, ThrowOnError>) => (options?.client ?? client).get<ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/names',
    ...options
});

/**
 * Create a new Split Vote Instruction Proposal Overwrite.
 */
export const proxyvotingSviProposalOverwriteCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingSviProposalOverwriteCreateData, ThrowOnError>) => (options.client ?? client).post<ProxyvotingSviProposalOverwriteCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingSviProposalOverwriteCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/svi/proposal/overwrite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieve a list of Split Vote Instruction Overwrite Reasons.
 */
export const proxyvotingSviProposalOverwriteReasonsList = <ThrowOnError extends boolean = false>(options?: Options<ProxyvotingSviProposalOverwriteReasonsListData, ThrowOnError>) => (options?.client ?? client).get<ProxyvotingSviProposalOverwriteReasonsListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/svi/proposal/overwrite/reasons',
    ...options
});

/**
 * List instruments
 */
export const transparencyInstrumentsList = <ThrowOnError extends boolean = false>(options?: Options<TransparencyInstrumentsListData, ThrowOnError>) => (options?.client ?? client).get<TransparencyInstrumentsListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/',
    ...options
});

/**
 * Create an instrument
 */
export const transparencyInstrumentsCreate = <ThrowOnError extends boolean = false>(options: Options<TransparencyInstrumentsCreateData, ThrowOnError>) => (options.client ?? client).post<TransparencyInstrumentsCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an instrument
 */
export const transparencyInstrumentsDestroy = <ThrowOnError extends boolean = false>(options: Options<TransparencyInstrumentsDestroyData, ThrowOnError>) => (options.client ?? client).delete<TransparencyInstrumentsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/{isin}/',
    ...options
});

/**
 * Get an instrument by ISIN
 */
export const transparencyInstrumentsRetrieve = <ThrowOnError extends boolean = false>(options: Options<TransparencyInstrumentsRetrieveData, ThrowOnError>) => (options.client ?? client).get<TransparencyInstrumentsRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/{isin}/',
    ...options
});

/**
 * Replace an instrument
 */
export const transparencyInstrumentsUpdate = <ThrowOnError extends boolean = false>(options: Options<TransparencyInstrumentsUpdateData, ThrowOnError>) => (options.client ?? client).put<TransparencyInstrumentsUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/{isin}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fetch the minimal projection of many instruments at once
 */
export const transparencyInstrumentsFetchMinimalCreate = <ThrowOnError extends boolean = false>(options: Options<TransparencyInstrumentsFetchMinimalCreateData, ThrowOnError>) => (options.client ?? client).post<TransparencyInstrumentsFetchMinimalCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/fetch-minimal/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List non-composite instruments not linked to any organization
 */
export const transparencyInstrumentsUnassociatedRetrieve = <ThrowOnError extends boolean = false>(options?: Options<TransparencyInstrumentsUnassociatedRetrieveData, ThrowOnError>) => (options?.client ?? client).get<TransparencyInstrumentsUnassociatedRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/unassociated/',
    ...options
});

/**
 * List public security IDs
 */
export const transparencyPublicSecurityIdsList = <ThrowOnError extends boolean = false>(options?: Options<TransparencyPublicSecurityIdsListData, ThrowOnError>) => (options?.client ?? client).get<TransparencyPublicSecurityIdsListResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyPublicSecurityIdsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/public-security-ids/',
    ...options
});

/**
 * Filter proxy intermediary ballot search results with cursor-based pagination.
 */
export const votingOperationsPiballotsFilterList = <ThrowOnError extends boolean = false>(options?: Options<VotingOperationsPiballotsFilterListData, ThrowOnError>) => (options?.client ?? client).get<VotingOperationsPiballotsFilterListResponses, unknown, ThrowOnError>({
    responseTransformer: votingOperationsPiballotsFilterListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-operations/piballots/filter',
    ...options
});

/**
 * Filter proxy intermediary meeting search results with cursor-based pagination. Returns meetings that are in scope for voting operations workflow, along with their scope information.
 */
export const votingOperationsPimeetingsFilterList = <ThrowOnError extends boolean = false>(options?: Options<VotingOperationsPimeetingsFilterListData, ThrowOnError>) => (options?.client ?? client).get<VotingOperationsPimeetingsFilterListResponses, unknown, ThrowOnError>({
    responseTransformer: votingOperationsPimeetingsFilterListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-operations/pimeetings/filter',
    ...options
});
